import React, { useState } from "react";
import "./LoginPage.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../Context/useAuth";
import { useForm, useFormState } from "react-hook-form";
import { Link } from "react-router-dom";
import ButtonSpinner from "../ButtonSpinner/ButtonSpinner";

type Props = {};

type LoginFormsInputs = {
  email: string;
  password: string;
};

const validation = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required"),
});

const LoginPage = (props: Props) => {
  const { loginUser } = useAuth();
  const {
    register,
    handleSubmit,
    formState,
    formState: { errors },
  } = useForm<LoginFormsInputs>({ resolver: yupResolver(validation) });

  const [loading, setLoading] = useState<boolean>(false);

  const handleLogin = async (form: LoginFormsInputs) => {
    setLoading(true);
    loginUser(form.email, form.password);
    //TODO remove in production
    await new Promise(resolve => setTimeout(resolve, 500));
    setLoading(false);
  };

  return (
    <section className="login">
      <div className="login-card shadow rounded bg-white col-md-4">
        <h3>Sign In</h3>
        <form onSubmit={handleSubmit(handleLogin)}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="email">Email address</Form.Label>
            <Form.Control
              id="email"
              type="email"
              placeholder="name@example.com"
              {...register("email")}
            />
          </Form.Group>
          {errors.email ? (
            <p className="text-red">{errors.email.message}</p>
          ) : (
            ""
          )}
          <Form.Group className="mb-3">
            <Form.Label htmlFor="password">Password</Form.Label>
            <Form.Control
              id="password"
              type="password"
              placeholder="***********"
              {...register("password")}
            />
            {errors.password ? (
              <p className="text-red">{errors.password.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
          <p className="forgot-password text-right">
            Forgot <a href="#">password?</a>
          </p>
          <p className="register-link">
            Not a member? <Link to="/register">Register</Link>
          </p>
          <div className="d-grid">
            {loading ? (<ButtonSpinner />) : (
            <Button type="submit" variant="primary">
              Submit
            </Button>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default LoginPage;
